$ ->
  $(document).on 'click', '.system-message .btn-close', (e) =>
    $(e.target).closest('.system-message').remove()
